module.exports = __webpack_public_path__ + "media/Game Winning Goal.f7d9b810.mp4";